export const greenUnisonBrand = {
    name: "Green Unison",
    legalName: "Green Unison Limited",

    taglines: {
        primary: "Tapping into Nature’s Wisdom",
        secondary: "from Roots to Radiance",
        footer: "Naturally grown and responsibly prepared — with renewable energy guiding every step, from farm to package.",
    },

    colors: {
        forest: "#06602B",
        green: "#00953B",
        mint: "#43FF8F",
        purple: "#6A0572",
        yellow: "#FFE150",
        lime: "#F8FF73",
        cream: "#FFFFDE",
        brown: "#8C5A2B",
        black: "#000000",
        charcoal: "#3F3F3F",
        gray: "#5B5B5B",
        softGray: "#E5E5E5",
    },

    links: {
        main: "https://greenunison.com",
        blog: "https://blog.greenunison.com",
        shop: "https://greenunison.com/shop",
        about: "https://greenunison.com/about",
        contact: "https://greenunison.com/contact",
        faq: "https://greenunison.com/faq",
    },
} as const;
